import { render } from "./TakEawaypizza.vue?vue&type=template&id=eb403aa8"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/package/TakEawaypizza.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "eb403aa8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('eb403aa8', __exports__)) {
    api.reload('eb403aa8', __exports__)
  }
  
  module.hot.accept("./TakEawaypizza.vue?vue&type=template&id=eb403aa8", () => {
    api.rerender('eb403aa8', render)
  })

}


export default __exports__